import { DEFAULT_AREA, Indicator, Threshold } from '@toggle/helpers';

export const indicatorsThresholds: Record<Indicator, Threshold> = {
  [Indicator.TLI]: {
    up: 0.15,
    down: -0.15,
    variants: DEFAULT_AREA,
    mid: 0,
  },
  [Indicator.RFI]: {
    up: 0.75,
    down: -0.75,
    variants: ['bearish', 'bullish'],
    mid: 0,
  },
  [Indicator.PI]: {
    up: 95,
    down: 5,
    variants: ['bearish', 'bullish'],
    mid: 50,
  },
  [Indicator.TI]: {
    up: 95,
    down: 5,
    variants: DEFAULT_AREA,
    mid: 50,
  },
};

export const mapIndicatorToSnake = {
  [Indicator.TLI]: 'spx.toggle_leading_indicator',
  [Indicator.RFI]: 'spx.toggle_range_finder_indicator',
  [Indicator.PI]: 'spx.toggle_peak_probability_indicator',
  [Indicator.TI]: 'spx.toggle_trough_probability_indicator',
};
